export type ErrorPayload = { error?: { code?: string; message?: string; fieldErrors?: unknown }; message?: string; requestId?: string };

export function errorMessage(payload: ErrorPayload, status: number): string {
  const message = payload.error?.message ?? payload.message ?? `请求失败（${status}）`;
  return payload.requestId ? `${message}（请求号：${payload.requestId}）` : message;
}

export function needsIdempotency(method = 'GET', path = ''): boolean {
  return !['GET', 'HEAD', 'OPTIONS'].includes(method.toUpperCase()) && !path.startsWith('/auth/');
}
